module.exports = __webpack_public_path__ + "static/img/shuzijishu-3.dff8a572.svg";